// section id constants
const CHANGE_TYPE = 'CHANGE_TYPE';
const CHANGE_QUESTIONS = 'CHANGE_QUESTIONS';
const START_AND_END_DATE = 'START_AND_END_DATE';
const CHANGE_DETAILS = 'CHANGE_DETAILS';
const WORK_INFORMATION_ITEMS = 'WORK_INFORMATION_ITEMS';
const REFERENCES_SECTION = 'REFERENCES_SECTION';
const CHANGE_REQUEST_SUMMARY = 'CHANGE_REQUEST_SUMMARY';
const APPROVERS_SECTION = 'APPROVERS_SECTION';
const RELATIONSHIPS = 'RELATIONSHIPS';
const COMPLETION_REVIEW = 'COMPLETION_REVIEW';


// section titles
const SECTION_TITLES = {
  CHANGE_TYPE: 'Change type',
  CHANGE_QUESTIONS: 'Change questions',
  START_AND_END_DATE: 'Scheduled start/end date',
  CHANGE_DETAILS: 'Change details',
  WORK_INFORMATION_ITEMS: 'Work information items',
  REFERENCES_SECTION: 'References',
  APPROVERS_SECTION: 'Approvers',
  CHANGE_REQUEST_SUMMARY: 'Change request summary',
  RELATIONSHIPS: 'Add relationship',
};

export {
  CHANGE_TYPE,
  CHANGE_QUESTIONS,
  START_AND_END_DATE,
  CHANGE_DETAILS,
  WORK_INFORMATION_ITEMS,
  REFERENCES_SECTION,
  APPROVERS_SECTION,
  CHANGE_REQUEST_SUMMARY,
  RELATIONSHIPS,
  SECTION_TITLES,
  COMPLETION_REVIEW,
};
